import './index.scss';
import React from 'react';
import { Avatar } from '@material-ui/core';
import { getUserImageLink } from '@utils';

interface Props {
  newId: string;
  name: string;
}

const UserInfo = ({ newId, name }: Props) => {
  return (
    <div className="user-info">
      <Avatar
        className="user-info__avatar-wrapper"
        alt="Itechart employee"
        src={getUserImageLink(newId)}
      />
      <span>{name}</span>
    </div>
  );
};

export default React.memo(UserInfo);
